<template>
	<div class="container">
		<Header />
		<MainClinicCust />
		<Footer />
	</div>
</template>

<script>
import Header from '@/layout/Header.vue';
import Footer from '@/layout/Footer.vue';
import MainClinicCust from '@/layout/MainClinicCust.vue';

export default {
	data() {
		return {

		}
	},
	components: {
		Header,
		Footer,
		MainClinicCust,
	},
	created() {

	},
	methods: {

	}
}
</script>
<style>

</style>
<style lang="less" scoped>
.container {
	width: 100%;
	max-width: 100% !important;
	min-height: calc(100vh - 144px);
}
</style>
